/* Squishy Chile: el submenú del encabezado se cierra al hacer scroll. Hacer clic en un botón del menú lleva a su landing. */
(function () {
  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    if (Math.abs(window.scrollY - lastY) > 8) {
      var m = document.querySelector('header-menu');
      if (m && m.getAttribute('aria-expanded') === 'true') {
        m.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
        setTimeout(function () {
          var a = document.activeElement;
          if (a && a !== document.body && m.contains(a) && a.blur) a.blur();
        }, 0);
      }
    }
    lastY = window.scrollY;
  }, { passive: true });
})();
